import { storeToRefs } from 'pinia';
import { type RouteLocationNormalizedGeneric, createRouter, createWebHistory } from 'vue-router';

import { useCustomerPortalSettingsStore } from '@abaninja/data-access-customer-portal-customer-portal';
import { getBrowserLanguage } from '@abaninja/util-i18n';
import { useRouterState } from '@abaninja/util-router';

import { switchLanguage } from '../plugins/i18n';
import { routes } from './routes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

function setHashFromRouteParams(to: RouteLocationNormalizedGeneric) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const hash = to.params.hash ?? to.redirectedFrom?.params.hash;

  if (typeof hash === 'string') {
    sessionStorage.setItem('hash', hash);

    return true;
  }

  return false;
}

router.beforeEach(async (to) => {
  const { isLoading } = storeToRefs(useRouterState());

  isLoading.value = true;

  if (to.meta.needsAuth) {
    setHashFromRouteParams(to);

    if (!sessionStorage.getItem('hash')) {
      // redirect to not found page
      return { name: '404' };
    }

    // hash is set so load default settings
    const { entity, getEntity } = useCustomerPortalSettingsStore();

    if (!entity.value) {
      await getEntity();
    }

    if (entity.value?.language) {
      await switchLanguage(entity.value.language);
    }
  } else {
    const language = getBrowserLanguage();

    await switchLanguage(language);
  }

  return true;
});

router.afterEach(() => {
  const { hasLoaded, isLoading } = storeToRefs(useRouterState());

  isLoading.value = false;
  hasLoaded.value = true;
});

export default router;
